import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Menu from "./Menu";

import logo from "../../assets/img/logo.png";

class Mobilemenu extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <Fragment>
        <Link className="navbar-brand" to="/" style={{ display: "flex" }}>
          <img src={logo} alt="" style={{ width: "45%" }} />
          <h3
            style={{
              marginTop: "10%",
              fontSize: "20px",
              color:  "black",
            }}
          >
            Gems
          </h3>
        </Link>
        {/* Menu */}
        <Menu location={this.props.location} viewEcommerce={this.props.viewEcommerce}/>
        {/* <Menu /> */}
      </Fragment>
    );
  }
}

export default Mobilemenu;
